"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReceiptHeaderByListApi = ReceiptHeaderByListApi;
exports.cancelReceiptInfo = cancelReceiptInfo;
exports.deleteReceiptHeaderApi = deleteReceiptHeaderApi;
exports.deleteReceiptTakerApi = deleteReceiptTakerApi;
exports.receiptAllInfoInitApi = receiptAllInfoInitApi;
exports.receiptHeaderInitApi = receiptHeaderInitApi;
exports.receiptInfoInitApi = receiptInfoInitApi;
exports.receiptList = receiptList;
exports.receiptTakerByListApi = receiptTakerByListApi;
exports.receiptTakerInitApi = receiptTakerInitApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function receiptList(params) {
  return (0, _request.default)({
    url: '/admin/merchant/receipt/list',
    method: 'GET',
    params: params
  });
}
function receiptInfoInitApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/receipt/save",
    method: 'post',
    data: data
  });
}
function receiptAllInfoInitApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/receipt/all/save",
    method: 'post',
    data: data
  });
}
function cancelReceiptInfo(params) {
  return (0, _request.default)({
    url: '/admin/merchant/receipt/delete',
    method: 'GET',
    params: params
  });
}
function receiptTakerInitApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/receipt/taker/save",
    method: 'post',
    data: data
  });
}
function receiptTakerByListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/receipt/taker/list',
    method: 'GET',
    params: params
  });
}
function deleteReceiptTakerApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/receipt/taker/delete',
    method: 'GET',
    params: params
  });
}
function receiptHeaderInitApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/receipt/header/save",
    method: 'post',
    data: data
  });
}
function deleteReceiptHeaderApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/receipt/header/delete',
    method: 'GET',
    params: params
  });
}
function ReceiptHeaderByListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/receipt/header/list',
    method: 'GET',
    params: params
  });
}